
addEventListener('DOMContentLoaded', () => {
	ActiveTab(null)

	// Make the tab buttons work
	const tabElements = document.querySelectorAll('div.tabbed_form div.tabs a.button')
	tabElements.forEach((tabElement: HTMLAnchorElement) => {
		tabElement.addEventListener('click', function (e) {
			e.stopPropagation()
			tabPressed(tabElement as HTMLAnchorElement)

			setTimeout(() => {
				if (window.location.href.indexOf(tabElement.href) >= 0 && tabElement.classList.contains('show')) {
					ActiveTab(tabElement)
				}
			}, 300)

		})
	})

	// mkae the next buttons work
	const nextElements = document.querySelectorAll('div.tabbed_form div.form button.next')
	nextElements.forEach(nextElement => {
		nextElement.addEventListener('click', function (e) {
			e.stopPropagation()
			nextPressed(nextElement as HTMLButtonElement)
			ActiveTab(null)
		})
	})

	// Make the invoicing checkbox work
	const invoicingCheckbox = document.querySelector('div.tabbed_form div.form.invoicing input#invoicing_customer_invoice_data')
	if (invoicingCheckbox) {
		invoicingCheckbox.addEventListener('click', function (e) {
			invoicingCheckboxClicked(invoicingCheckbox as HTMLInputElement)
		})

		// Firefox remembers the last state after a refresh
		invoicingCheckboxClicked(invoicingCheckbox as HTMLInputElement)
	}

	// Make the content select work
	const contentSelect = document.querySelector('div.tabbed_form div.form.contents #content_project_id')
	if (contentSelect) {
		contentSelect.addEventListener('click', function (e) {
			contentSelectSelected(contentSelect as HTMLSelectElement)
		})

		// Firefox remembers the last state after a refresh
		contentSelectSelected(contentSelect as HTMLSelectElement)
	}

	// THe contents checkboxes should check if there are blockquotes
	const contentCheckboxes = document.querySelectorAll('div.tabbed_form div.form.contents .field.content_tree input[type="checkbox"]')
	contentCheckboxes.forEach(contentCheckbox => {
		contentCheckbox.addEventListener('click', function (e) {
			contentCheckboxPressed(contentCheckbox as HTMLInputElement)
		})
	})

	createSummary();

})

function ActiveTab(pressedTab) {
	const elements = document.querySelectorAll('.button.show')

	if (!pressedTab) {
		elements.forEach((item: HTMLDivElement) => {
			item.style.boxShadow = ''
		})

		if (elements.length > 0) {
			(elements[elements.length - 1] as HTMLDivElement).style.boxShadow = '0 0 20px -3px #676464'
		}
	} else {
		elements.forEach((item: HTMLDivElement) => {
			item.style.boxShadow = ''
		})

		pressedTab.style.boxShadow = '0 0 20px -3px #676464'
	}

}

let allowedToNavigate = true

const tabPressed = function (currentTabElement: HTMLAnchorElement, fromNextButton: boolean = false) {

	if (!currentTabElement.classList.contains('show')) {
		return
	}


	//First check if all formas have valid field entries
	if (!fromNextButton) {
		const tabElements = document.querySelectorAll('div.tabbed_form div.tabs a.button')
		tabElements.forEach(element => {
			const tabElement = element as HTMLAnchorElement

			if (
				tabElement != currentTabElement &&
				tabElement.classList.contains('show')) {

				const hash = getHash(tabElement)
				const formButton = document.querySelector('div.tabbed_form div.form.' + hash + ' button.next') as HTMLButtonElement
				if (formButton) {
					nextPressed(formButton, true)
				}
			}
		})
	}

	if (!allowedToNavigate) {
		return
	}

	const hash = getHash(currentTabElement)
	const formDivs = document.querySelectorAll('div.tabbed_form div.form')
	formDivs.forEach(formDiv => {
		if (formDiv.classList.contains(hash)) {
			formDiv.classList.add('show')
		}
		else {
			formDiv.classList.remove('show')
		}
	})

	createSummary()
}

const nextPressed = function (nextElement: HTMLButtonElement, fromTab: boolean = false) {

	const navigateToNextTab = function (currentTab: string) {
		if (!fromTab) {
			let nextTabFound = false
			const tabElements = document.querySelectorAll('div.tabbed_form div.tabs a.button')
			tabElements.forEach(element => {
				if (currentTab.length > 0) {

					const tabElement = element as HTMLAnchorElement
					tabElement.classList.add('show')

					if (currentTab == 'onmore') {
						tabPressed(tabElement, true)
						currentTab = ''
						nextTabFound = true
					}

					const hash = getHash(tabElement)
					if (currentTab == hash) {
						currentTab = 'onmore'
					}
				}
			})

			if (!nextTabFound) {
				const frm = document.querySelector('form#frm') as HTMLFormElement
				if (frm) {
					frm.submit()
				}
			}

		}
	}

	const generalCheck = function (formDiv: HTMLDivElement): boolean {

		let result = true

		const formElements = formDiv.querySelectorAll('input[required], textarea[required]')
		formElements.forEach(element => {
			if (result) {
				const formElement = element as HTMLInputElement
				if (!formElement.value) {

					const label = formElement.parentNode.parentNode.querySelector('label')
					if (label) {
						alert(label.textContent + " veld is leeg. \n\n" + (formElement.parentNode.parentNode.querySelector('.info')?.textContent ?? ''))
						result = false
					}
				}
			}
		})

		return result
	}

	const invoicingCheck = function (formDiv: HTMLDivElement): boolean {

		let result = true

		const formElements = formDiv.querySelectorAll('input[required]:not(input[disabled])')

		formElements.forEach(element => {
			if (result) {
				const formElement = element as HTMLInputElement
				if (!formElement.value) {

					const label = formElement.parentNode.parentNode.querySelector('label')
					if (label) {
						alert(label.textContent + " veld is leeg. \n\n" + (formElement.parentNode.parentNode.querySelector('.info')?.textContent ?? ''))
						result = false
					}
				}
			}
		})

		return result
	}

	const contentsCheck = function (formDiv: HTMLDivElement): boolean {
		return true
	}

	const summaryCheck = function (formDiv: HTMLDivElement): boolean {

		const autorizedCheckbox = document.querySelector('div.tabbed_form div.form.summary input#user_is_autorized_checkbox') as HTMLInputElement

		let result = true

		if (!autorizedCheckbox.checked && !fromTab) {

			alert(autorizedCheckbox.getAttribute('data-error'));

			result = false
		}

		return result
	}

	const init = function (nextElement) {

		const formDiv = nextElement.parentNode.parentNode.parentNode as HTMLDivElement
		let currentTab = ''

		if (formDiv.classList.contains('general')) {
			currentTab = 'general'
			allowedToNavigate = generalCheck(formDiv)
		}
		else if (formDiv.classList.contains('invoicing')) {
			currentTab = 'invoicing'
			allowedToNavigate = invoicingCheck(formDiv)
		}
		else if (formDiv.classList.contains('contents')) {
			currentTab = 'contents'
			allowedToNavigate = contentsCheck(formDiv)
		}
		else if (formDiv.classList.contains('summary')) {
			currentTab = 'summary'
			allowedToNavigate = summaryCheck(formDiv)
		}

		if (allowedToNavigate && currentTab.length > 0) {
			createSummary()
			navigateToNextTab(currentTab)
		}
	}

	init(nextElement)
}

const getHash = function (anchor: HTMLAnchorElement): string {
	const url = new URL(anchor.href)
	const hashValue = url.hash.substring(1)
	return hashValue
}

const invoicingCheckboxClicked = function (checkbox: HTMLInputElement) {
	const specificElements = document.querySelectorAll('div.tabbed_form div.form.invoicing input.specific')
	specificElements.forEach(element => {
		const input = element as HTMLInputElement
		input.disabled = checkbox.checked
	})
}

const contentSelectSelected = function (selected: HTMLSelectElement) {
	const specificElements = document.querySelectorAll('div.tabbed_form div.form.contents input.specific')
	specificElements.forEach(element => {
		const input = element as HTMLInputElement
		input.disabled = parseInt(selected.value) != 0
	})
}

const contentCheckboxPressed = function (checkbox: HTMLInputElement) {

	const blockquote = checkbox.nextElementSibling?.nextElementSibling?.nextElementSibling as HTMLElement
	if (blockquote && blockquote.tagName === 'BLOCKQUOTE') {
		const childCheckboxes = blockquote.querySelectorAll('input.specific')
		childCheckboxes.forEach(element => {
			const childCheckbox = element as HTMLInputElement
			childCheckbox.checked = checkbox.checked
		})
	}
}

const createSummary = function () {

	const summary = document.querySelector('div.tabbed_form div.form.summary div.summary_div')
	if (!summary) {
		return
	}

	summary.innerHTML = ''

	const elements = document.querySelectorAll('div.tabbed_form h2, div.tabbed_form div.field')

	elements.forEach(element => {

		if (element.tagName == 'H2') {
			if (!element.classList.contains('noshow')) {
				summary.innerHTML += element.outerHTML
			}
		}

		if (element.tagName == 'DIV') {

			let html = '<div class="row">'
			let disabled = false

			const label = element.querySelector('label')

			if (label) {

				html += '<div class="label">' + label.innerHTML + '</div>'

				html += '<div class="inputs">'

				const inputs = element.querySelectorAll('select, input, textarea')
				inputs.forEach((i) => {

					const input = i as HTMLInputElement
					const classes = getClasses(input)
					const value = getHumanReadableText(input)

					disabled = value === 'disabled'

					html += '<div class="' + classes + '">' + value + '</div>'

				})
				html += '</div>'

				html += '</div>'

				if (!disabled) {
					summary.innerHTML += html
				}
			}

		}
	})

	function getLabelText(input: HTMLInputElement): string | null {
		// Case 1: Find label using 'for' attribute matching the input's id
		const label = document.querySelector(`label[for="${input.id}"]`);
		if (label) {
			return label.textContent || null;
		}

		// Case 2: Check if the input is directly wrapped inside a label
		if (input.parentElement && input.parentElement.tagName.toLowerCase() === 'label') {
			return input.parentElement.textContent?.trim() || null;
		}

		return null;
	}

	function getHumanReadableText(element: HTMLElement): string | null {
		if (element instanceof HTMLSelectElement) {
			// Get the text of the selected option in a <select>
			const selectedOption = element.options[element.selectedIndex];
			return selectedOption ? selectedOption.text : null;
		} else if (element instanceof HTMLInputElement) {

			if (element.disabled) {
				return 'disabled'
			}

			// For radio buttons and checkboxes, return the label's text
			if (element.type === 'radio' || element.type === 'checkbox') {
				if (element.checked) {
					return getLabelText(element) + '<br>';
				}
				else {
					return 'disabled'
				}
			}
			else if (element.type === 'date') {
				return formatDateToAmsterdam(element.value)
			}
			else if (element.type === 'hidden') {
				const next = element.nextElementSibling
				if (next.tagName === 'DIV' && next.classList.contains('selected')) {
					return next.innerHTML
				}
				else {
					return 'disabled'
				}
			}
			else {
				return element.value;
			}
		} else if (element instanceof HTMLTextAreaElement) {
			// For textareas
			return element.value;
		}
		return '';
	}

	function getClasses(element: HTMLInputElement): string {
		const type = element.type !== 'hidden' ? element.type : '';
		return element.tagName.toLowerCase() + ' ' + type + ' ' + element.name
	}

	function formatDateToAmsterdam(dateString: string): string {

		if (dateString.length == 0) {
			return ''
		}

		// Convert the string to a Date object
		const date = new Date(dateString);

		// Use Intl.DateTimeFormat for the Dutch locale (Netherlands/Amsterdam)
		const formatter = new Intl.DateTimeFormat('nl-NL', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
		});

		return formatter.format(date);
	}
}